import { connect } from 'react-redux'
import TopPanel from './TopPanel'
import { fetchCategories, categoryChecked, search } from './topPanelActions'

const mapStateToProps = state => ({
  categories: state.topPanel.categories,
  email: state.authorization.email
})

const mapDispatchToProps = dispatch => ({
  fetchCategories: (locale) => dispatch(fetchCategories(locale)),
  onCategoryChecked: id => dispatch(categoryChecked(id)),
  onSearchTextChanged: text => dispatch(search(text))
})

// Object-container for stateless component TopPanel
const TopPanelContainer = connect(mapStateToProps, mapDispatchToProps)(TopPanel)
export default TopPanelContainer
